export default {"src":"/_next/static/media/narendra-benefit-svg.ca6ce419.svg","height":54,"width":56,"blurWidth":0,"blurHeight":0};